module.exports = __webpack_public_path__ + "static/media/YB5M01_1.455ece2c.jpg";